<template>
  <origin-groups-form
    :origin-id="origingroupId"
    :distribution-id="distributionId"
    details
    @submit="editErrorPage"
    @close="onClose"
  />
</template>
<script>
import OriginGroupsForm from './OriginGroupsForm.vue'

export default {
  name: 'EditOriginGroup',
  components: {
    OriginGroupsForm,
  },
  data() {
    return {
      distributionId: null,
      origingroupId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
    this.origingroupId = this.$route.params.origingroupId
  },
  methods: {
    editErrorPage(query) {
      this.$store.dispatch('cdn/updateOriginGroup', query).then(() => {
        this.successToast('Origin group was updated')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating origin group.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-origins', params: { id: this.distributionId, activeTab: 1 } })
    },
  },
}
</script>
